import * as yup from "yup";

/**
 * Shared constants and validation utilities for chamber member forms
 * (CreateChamberMember, EditChamberMember, ManageAChamberMember, etc.)
 */

/** Maximum character count for the company description field */
export const CHARACTER_LIMIT_DESCRIPTION = 2000;

/**
 * Reusable Yup address validation schema object.
 * All address fields are optional strings.
 */
export const addressValidationSchema = yup.object({
  province: yup.string().required("Province/State is required"),
  city: yup.string().required("City is required"),
  postalCode: yup.string(),
  streetAddress: yup.string(),
});

/**
 * Scrolls to the first validation error visible on the page.
 * Looks for MUI error classes and scrolls the enclosing form control into view.
 *
 * @param formikSubmitCount - The current formik submitCount value
 * @param formikErrors - The current formik errors object
 */
export const scrollToFirstValidationError = (
  formikSubmitCount: number,
  formikErrors: Record<string, unknown>
): void => {
  if (formikSubmitCount > 0 && Object.keys(formikErrors).length > 0) {
    const firstErrorField = document.querySelector(
      '.Mui-error, .MuiFormHelperText-root.Mui-error'
    );
    if (firstErrorField) {
      const container =
        firstErrorField.closest('.MuiFormControl-root') || firstErrorField;
      container.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
};
